import styled from "styled-components";
import { colors } from "common/const/colors";
import { TextBody1, TextHeading3, TextTitle2 } from "..";
import { DefaultButton } from "../Button/new/DefaultButton";
import { CloseButton } from "../Button/new/CloseButton";
import { shortButtonStyle } from "common/const/buttonStyles";
import { I18N_KEYS } from "common/i18n/keys";
import { t } from "i18next";
import { Divider } from "../Etc/divider";

const DefaultModalLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ layoutGap }) => layoutGap ?? "2rem"};
`;

const DefaultModalHeader = styled.div`
  display: flex;
  flex-direction: row;
`;

const DefaultModalBody = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  gap: 1rem;
  flex: 1;
`;

const DefaultModalContent = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  gap: ${({ gap }) => gap ?? "1.25rem"};

  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;

  & > * {
    flex-shrink: 0;
  }
`;

const DefaultModalFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  /* margin-top: 2rem; */

  & > * {
    flex: 1;
  }
`;

export const DefaultModal = ({
  title,
  onClose,
  style,
  direction = "column",
  gap,
  layoutGap,
  fixedWidth,
  fixedHeight,
  footer,
  showFooterDivider,
  children,
}) => (
  <DefaultModalLayout
    layoutGap={layoutGap}
    style={{ ...style, width: fixedWidth, height: fixedHeight }}>
    <DefaultModalHeader
      style={{ justifyContent: onClose ? "space-between" : "center" }}>
      {(title || onClose) && <TextHeading3>{title}</TextHeading3>}
      {onClose && <CloseButton size={"1.2rem"} onClick={onClose} />}
    </DefaultModalHeader>
    <DefaultModalBody>
      <DefaultModalContent direction={direction} gap={gap}>
        {children}
      </DefaultModalContent>
      {showFooterDivider && (
        <Divider
          style={{
            marginLeft: "-1.5rem",
            marginRight: "-1.5rem",
            width: "calc(100% + 3rem)",
          }}
        />
      )}
    </DefaultModalBody>
    {footer && <DefaultModalFooter>{footer}</DefaultModalFooter>}
  </DefaultModalLayout>
);

export const DefaultTextModal = ({
  title,
  bodyText,
  bodyAlign,
  rightButtonText,
  rightButtonOnClick,
  leftButtonText,
  leftButtonOnClick,
}) => (
  <DefaultModalLayout
    style={{
      gap: "1rem",
      minWidth: "20rem",
      minHeight: "10rem",
      justifyContent: "center",
      alignItems: "center",
      whiteSpace: "pre-line",
    }}>
    <DefaultModalBody
      style={{ alignItems: "center", justifyContent: "center", flex: 1 }}>
      {title && (
        <TextTitle2 style={{ textAlign: "center" }}>{title}</TextTitle2>
      )}
      {bodyText && (
        <TextBody1 style={bodyAlign ? { textAlign: bodyAlign } : undefined}>
          {bodyText}
        </TextBody1>
      )}
    </DefaultModalBody>

    <DefaultModalFooter style={{ gap: "1rem" }}>
      {leftButtonText && (
        <DefaultButton
          style={shortButtonStyle}
          onClick={leftButtonOnClick}
          borderColor={colors.MainBlue}
          textColor={colors.MainBlue}>
          {leftButtonText}
        </DefaultButton>
      )}
      {rightButtonText && (
        <DefaultButton
          style={shortButtonStyle}
          onClick={rightButtonOnClick}
          fillColor={colors.MainBlue}
          textColor={colors.White}>
          {rightButtonText}
        </DefaultButton>
      )}
    </DefaultModalFooter>
  </DefaultModalLayout>
);

DefaultTextModal.Confirm = ({
  title,
  message,
  bodyAlign,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
}) => (
  <DefaultTextModal
    title={title}
    bodyText={message}
    bodyAlign={bodyAlign}
    leftButtonText={t(cancelText ?? I18N_KEYS.common.button.cancel)}
    leftButtonOnClick={onCancel}
    rightButtonText={t(confirmText ?? I18N_KEYS.common.button.confirm)}
    rightButtonOnClick={onConfirm}
  />
);

DefaultTextModal.Message = ({ message, onOk }) => (
  <DefaultTextModal
    bodyText={message}
    rightButtonText={t(I18N_KEYS.common.confirm)}
    rightButtonOnClick={onOk}
  />
);
